import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {
  DestroyableComponent,
  ErrorDialogComponent,
  PageNotFoundComponent,
  UnderConstructionComponent
} from '@shared/component';
import {FormsModule} from '@angular/forms';
import {BreadCrumbComponent} from '@shared/component/bread-crumb/bread-crumb.component';


import {CardModule} from '@card';
import {SerenityFormsModule} from '@form';
import {SerenityPipeModule} from '@pipe';
import {DataListModule} from '@dataList';
import {SerenityDirectiveModule} from '@directive';
import {DialogModule} from '@dialog';
import {MenuModule} from '@menu';
import {MainPageModule} from '@shared/module/main-page/main-page.module';
import {TextExpanderComponent} from "@shared/component/text-expander/text-expander.component";


@NgModule({
  declarations: [
    PageNotFoundComponent,
    DestroyableComponent,
    UnderConstructionComponent,
    BreadCrumbComponent,
    ErrorDialogComponent,
    TextExpanderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    CardModule,
    SerenityFormsModule,
    SerenityPipeModule,
    DataListModule,
    SerenityDirectiveModule,
    MenuModule,
    MainPageModule
  ],
  providers: [],
  exports: [
    PageNotFoundComponent,
    UnderConstructionComponent,
    BreadCrumbComponent,
    CardModule,
    SerenityFormsModule,
    SerenityPipeModule,
    DataListModule,
    SerenityDirectiveModule,
    DialogModule,
    MenuModule,
    MainPageModule,
    ErrorDialogComponent,
    DestroyableComponent,
    TextExpanderComponent
  ]
})
export class SharedModule {
}
